<template>
  <div class="document-content-records">
    <v-divider v-if="records.length"/>
    <div v-for="(record, index) in records" :key="index">
      <div class="document-content-record">
        <p style=" border-bottom: 1px dashed gray">
          <span class="accent--text">{{ record.nomenklatura_id}}</span> {{ record.name}}
        </p>
        <div style="text-align: right;">
          <v-layout>
            <v-flex xs12 class="text-xs-right"><i>{{ record.kolichestvo}}</i> * <i>{{ record.tsena}}</i> = <i>{{
              record.summa | numberFormat(2, '.', ' ')}}</i></v-flex>
          </v-layout>

        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <p class="text-xs-right document-content-record">
      Итого: <strong>{{ summa | numberFormat(2, '.', ' ') }}</strong>
    </p>
  </div>
</template>

<script>
import balanceDocumentRecordsDisplay from '../mixins/balanceDocumentRecordsDisplay'

export default {
  name: 'BalanceDocumentList',
  mixins: [
    balanceDocumentRecordsDisplay
  ]
}
</script>

<style lang="stylus">
  .document-content-records {
    //margin-bottom: 16px
  }

  .document-content-record {
    padding: 16px
  }

</style>
